export const FEATURED_POSTS_COLLECTION_SLUG = 'featured-posts'
export const GEAR_SLUG = 'gear'
export const PREGNANCY_SLUG = 'pregnancy'
export const PREGNANCY_WEEK_BY_WEEK_SLUG = 'pregnancy-week-by-week'
export const PARENTING_SLUG = 'parenting'
export const SAMPLE_REGISTRIES_SLUG = 'sample-registries'
export const FRIENDS_AND_FAMILY_SLUG = 'friends-and-family'
export const PREGNANCY_FIRST_TRIMESTER_SLUG = 'first-trimester-of-pregnancy'
export const PREGNANCY_SECOND_TRIMESTER_SLUG = 'second-trimester-of-pregnancy'
export const PREGNANCY_THIRD_TRIMESTER_SLUG = 'third-trimester-of-pregnancy'
export const YOUR_BABY_WEEK_BY_WEEK_SLUG = 'your-baby-week-by-week'
